const numsToConvert = document.querySelectorAll(
	'[data-modifier="make-double-digit"]',
)

function makeDoubleDigit(num) {
	let res = null
	if (typeof num !== 'number' && typeof num !== 'string') return res
	res = num.toString().trim().length < 2 ? '0' + num : num
	return res.trim()
}

numsToConvert.forEach((el) => {
	el.innerText = makeDoubleDigit(el.innerText.trim())
})

const grabScrollContainer = document.querySelector('.grab-scroll-container')
let pos = { top: 0, left: 0, x: 0, y: 0 }

const mouseDownHandler = function (e) {
	pos = {
		// The current scroll
		left: grabScrollContainer.scrollLeft,
		top: grabScrollContainer.scrollTop,
		// Get the current mouse position
		x: e.clientX,
		y: e.clientY,
	}
	if (e.target.tagName === 'IMG') return
	grabScrollContainer.classList.remove('cursor-grab')
	grabScrollContainer.classList.add('cursor-grabbing')
	grabScrollContainer.classList.add('user-none')
	document.addEventListener('mousemove', mouseMoveHandler)
	document.addEventListener('mouseup', mouseUpHandler)
}

const mouseMoveHandler = function (e) {
	// How far the mouse has been moved
	const dx = e.clientX - pos.x
	const dy = e.clientY - pos.y

	// // Scroll the element
	grabScrollContainer.scrollTop = pos.top - dy
	grabScrollContainer.scrollLeft = pos.left - dx
}

const mouseUpHandler = function () {
	document.removeEventListener('mousemove', mouseMoveHandler)
	document.removeEventListener('mouseup', mouseUpHandler)

	grabScrollContainer.classList.remove('cursor-grabbing')
	grabScrollContainer.classList.remove('user-none')
	grabScrollContainer.classList.add('cursor-grab')
}

if (grabScrollContainer)
	grabScrollContainer.addEventListener('mousedown', mouseDownHandler)

export default {
	numsToConvert: numsToConvert,
	grabScrollContainer: grabScrollContainer,
}
